import { AppAbility } from "configs/casl";
import { PermissionRequirement } from "constants/types/permission";

function checkCode(ability: AppAbility, code: string): boolean {
  const [subject, action] = code.split(":");
  return !!(subject && action && ability.can(action, subject));
}

/**
 * Kiểm tra xem ability có thỏa mãn requirement không.
 *
 * @param defaultWhenUndefined - giá trị trả về khi requirement là undefined.
 *   - `false` (strict): dùng cho navbar — item không khai báo required thì ẩn.
 *   - `true` (permissive): dùng cho action buttons — không khai báo permission thì vẫn hiện.
 */
export function canAccessRequirement(
  ability: AppAbility,
  requirement: PermissionRequirement | undefined,
  defaultWhenUndefined = false,
): boolean {
  if (requirement === undefined) return defaultWhenUndefined;

  if (typeof requirement === "string") return checkCode(ability, requirement);

  if (Array.isArray(requirement)) {
    return requirement.some((code) => checkCode(ability, code));
  }

  if (requirement.public) return true;
  if (requirement.fullAccessOnly) return ability.can("manage", "all");
  if (requirement.anyOf?.length) {
    return requirement.anyOf.some((code) => checkCode(ability, code));
  }
  if (requirement.allOf?.length) {
    return requirement.allOf.every((code) => checkCode(ability, code));
  }
  return false;
}
